import { networkService } from "services/networkService";
import {
  METHOD_MANAGEMENT_PACK_LIST,
  METHOD_MANAGEMENT_PACK_CREATE,
  METHOD_MANAGEMENT_PACK_UPDATE,
  METHOD_MANAGEMENT_PACK_DELETE,
  METHOD_MANAGEMENT_PACK_DETAIL,
} from "constants/admin/masters/vrops";
class ManagementPackService {
  getAll = (data) => {
    return networkService
      .post(METHOD_MANAGEMENT_PACK_LIST, data)
      .then((response) => response.data);
  };
  getDetail = (id) => {
    const updatedMethodName = METHOD_MANAGEMENT_PACK_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  create = (data) => {
    return networkService
      .post(METHOD_MANAGEMENT_PACK_CREATE, data)
      .then((response) => response.data);
  };
  update = (data, id) => {
    const updatedMethodName = METHOD_MANAGEMENT_PACK_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  delete = (id,is_delete=false) => {
    const updatedMethodName = METHOD_MANAGEMENT_PACK_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };
}
export default ManagementPackService;
